import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Grid, Button } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import validator from "validator";
import axios from "axios";
import toast from "react-hot-toast";
import { apiCall } from "../../utils/action";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import moment from "moment";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Checkbox from "@mui/material/Checkbox";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import Preloader from "../../helpers/Preloader";
import "../../../assets/styles/containers/_agreements.scss";
import "../../common/froalaHtmlEditor/FroalaEditorStyles.scss";
// pdf converts
import pdfMake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import htmlToPdfmake from "html-to-pdfmake";
// pdf converts

const { detect } = require("detect-browser");
const browser = detect();

const AgreementWebViewNSignature = () => {
  const [showLoader, setShowLoader] = useState();
  const [date1, setDate1] = useState(new Date());
  const [ipAddress, setIPAdress] = useState("");
  const [date1Error, setDate1Error] = useState(false);
  const [date1ErrorText, setDate1ErrorText] = useState("");
  const [date2, setDate2] = useState(new Date());
  const [clientNameOne, setClientNameOne] = useState("");
  const [clientNameOneError, setClientNameOneError] = useState("");
  const [clientNameOneErrorText, setClientNameOneErrorText] = useState("");
  const [clientNameTwo, setClientNameTwo] = useState("");
  const [clientNameTwoError, setClientNameTwoError] = useState("");
  const [agreementContent, setAgreementContent] = useState("");
  const [agreementName, setAgreementName] = useState("");
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [pdfFile, setPdfFile] = useState();
  let navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  let agreementIdParam = Number(searchParams.get("aid"));
  let companyIdParam = searchParams.get("cid");
  let orderIdParam = searchParams.get("oid");
  let userIdParam = searchParams.get("uid");
  let uniqueIdParam = searchParams.get("uniq");
  let emailParamEncoded = encodeURIComponent(searchParams.get("email"));
  let emailParam = decodeURIComponent(emailParamEncoded.replace(/\%20/g, "+"));
  const removeNumericRegex = /\d+/g;

  // Function to remove numeric characters
  function removeNumeric(inputString) {
    return inputString.replace(removeNumericRegex, "").trim();
  }

  function applyStylesToHtmlString(htmlString) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    const stylesMap = {
      'fr-fic': {
        'display': 'block',
        'float': 'none',
        'margin': '0 auto 10px auto',
        'text-align': 'center'
      },
      'fr-fil': {
        'display': 'inline-block',
        'float': 'left',
        'margin': '0 18px 10px 0',
        'text-align': 'left',
        'vertical-align': 'top'
      },
      'fr-dib': {
        'display': 'block',
        'float': 'none',
        'margin': '5px auto',
        'vertical-align': 'top',
      },
      'fr-dii': {
        'display': 'inline-block',
        'vertical-align': 'top',
      },
      'fr-fir': {
        'display': 'inline-block',
        'float': 'right',
        'margin': '0 0 10px 18px',
        'text-align': 'right',
        'vertical-align': 'top'
      },
      'fr-bordered': {
        'border': '5px solid #CCCCCC',
        'border-top': '5px solid #CCCCCC',
        'border-right': '5px solid #CCCCCC',
        'border-bottom': '5px solid #CCCCCC',
        'border-left': '5px solid #CCCCCC',
        'box-sizing': 'content-box',
      },
      'fr-rounded': {
        'border-radius': '10px',
        'overflow': 'hidden',
      },
    };
    const applyClassStyles = (element) => {
      const existingStyles = element.style.cssText
        .split(';')
        .filter(style => style.trim().length > 0)
        .reduce((styleObj, style) => {
          const [key, value] = style.split(':').map(s => s.trim());
          if (key && value) {
            styleObj[key] = value;
          }
          return styleObj;
        }, {});
      const imageOnlyClasses = ['fr-bordered', 'fr-rounded', 'fr-shadow', 'fr-highlighted', 'fr-thick'];
      for (const className in stylesMap) {
        if (element.classList.contains(className)) {
          if (element.tagName !== 'IMG' && imageOnlyClasses.includes(className)) continue;
          const styles = stylesMap[className];
          for (const [key, value] of Object.entries(styles)) {
            existingStyles[key] = value;
          }
        }
      }
      const isAlignableImageBlock = element.tagName === 'IMG' || element.classList.contains('fr-img-caption');
      if (isAlignableImageBlock && !element.classList.contains('fr-dii')) {
        const isRight = element.classList.contains('fr-fir');
        const isCenter = element.classList.contains('fr-fic');
        // default alignment: left, unless the element explicitly carries a center/right froala class
        existingStyles.display = 'block';
        existingStyles.float = 'none';
        if (isRight) {
          existingStyles.margin = '5px 0 10px auto';
          existingStyles['text-align'] = 'right';
        } else if (isCenter) {
          existingStyles.margin = '0 auto 10px auto';
          existingStyles['text-align'] = 'center';
          if (element.tagName === 'IMG') {
            existingStyles['margin-left'] = 'auto';
            existingStyles['margin-right'] = 'auto';
          }
        } else {
          existingStyles.margin = '5px auto 10px 0';
          existingStyles['text-align'] = 'left';
        }
      }
      element.style.cssText = Object.entries(existingStyles)
        .map(([key, value]) => `${key}: ${value};`)
        .join(' ');
    };
    tempDiv.querySelectorAll('.fr-img-caption').forEach((captionElement) => {
      const imageElement = captionElement.querySelector('img');
      if (!imageElement) return;
      ['fr-bordered', 'fr-rounded', 'fr-shadow', 'fr-highlighted', 'fr-thick'].forEach((className) => {
        if (captionElement.classList.contains(className)) imageElement.classList.add(className);
      });
    });
    tempDiv.querySelectorAll('img, .fr-img-caption, .fr-img-wrap, .fr-inner').forEach(applyClassStyles);
    tempDiv.querySelectorAll('.fr-inner').forEach((captionElement) => {
      captionElement.style.display = 'block';
      captionElement.style.width = '100%';
      captionElement.style.textAlign = 'center';
    });
    return tempDiv.innerHTML;
  }

  //get agreement details
  const GetAgreementDetails = () => {
    setShowLoader(true);
    const formdata = { user_id: userIdParam, company_id: companyIdParam, agreement_id: [agreementIdParam], order_id: orderIdParam, email: emailParam, unique_id: uniqueIdParam };
    apiCall(
      (response) => {
        const { data, message, success, status_code } = response.data;
        if (success) {
          let normalizedAgreementBody = (data[0]?.agreement_body || "").replace(/(\w[\w-]*)=""+([^"]*?)""+/g, '$1="$2"');
          let imagesUpdatedString = applyStylesToHtmlString(normalizedAgreementBody);
          let modifiedHtml = convertFontTagsToInlineStyles(imagesUpdatedString);
          let regexPattern2 = /\"=\"\"/g;
          const replacedString2 = modifiedHtml.replace(regexPattern2, "");
          setAgreementContent(replacedString2);
          let agreeName = `${data[0]?.name}.pdf`;
          setAgreementName(agreeName);
          setShowLoader(false);
        } else {
          // navigateing to agreement already signed page if the agreement is already signed
          if (status_code === 400) {
            if (message === "Invalid link.") navigate("/agreement-invalid");
            else navigate("/agreement-signed");
          } else toast.error(message);
          setShowLoader(false);
        }
      },
      formdata,
      "GET_AGREEMENT_CONTENT"
    );
  };

  const getIP = async () => {
    try {
      // Make a request to ipinfo.io to get IP and browser information
      const response = await axios.get("https://api.ipify.org/?format=json");
      setIPAdress(response.data.ip);
    } catch (error) {
      console.error("Error capturing IP and browser info:", error);
    }
  };

  useEffect(() => {
    getIP();
  }, []);

  const sendSignedAgreement = (convertedPdf) => {
    setShowLoader(true);
    toast.dismiss();
    // const formdata = new FormData();
    const formdata = {
      user_id: userIdParam,
      ip_address: ipAddress,
      browser_info: JSON.stringify({ name: browser.name, browser_version: browser.version, os: removeNumeric(browser.os) }),
      company_id: companyIdParam,
      agreement_id: agreementIdParam,
      inspection_id: orderIdParam,
      agreement_file: convertedPdf,
      user_name: `${clientNameOne?.trim()}${clientNameTwo !== "" ? `,${clientNameTwo?.trim()}` : ""}`,
      agreement_signed_date: `${date1},${clientNameTwo !== "" && date2 !== "" ? `,${date2}` : ""}`,
      agreement_file_name: agreementName,
      email: emailParam,
      unique_id: uniqueIdParam,
    };
    apiCall(
      (response) => {
        const { message, success } = response.data;
        if (success) {
          setShowLoader(false);
          navigate("/accept-agreement", { state: { emailParam } });
        } else {
          toast.error(message);
          console.log("else ", message);
          setShowLoader(false);
        }
      },
      formdata,
      "UPLOAD_SIGNED_AGREEMENT"
    );
  };

  const timestramp1 = moment(date1).format("YYYY-MM-DD");
  const timestramp2 = moment(date2).format("YYYY-MM-DD");

  // signed HTML to PDF conversion
  async function blobToDataUrl(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  async function redrawAsPng(dataUrl) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth || img.width;
        canvas.height = img.naturalHeight || img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = reject;
      img.src = dataUrl;
    });
  }

  async function imageToBase64(url) {
    const response = await fetch(url);
    const blob = await response.blob();
    const dataUrl = await blobToDataUrl(blob);
    return redrawAsPng(dataUrl);
  }

  const fetchUrl = () => {
    const currentUrl = window.location.href;
    if (currentUrl.includes("develop") || currentUrl.includes("integration") || currentUrl.includes("localhost")) {
      return "https://cloudfront.portal.palmtech.dev/font-family"
    } else if (currentUrl.includes("staging")) {
      return "https://cloudfront.staging.portal.palmtech.com/font-family"
    } else if (currentUrl.includes("portal")) {
      return "https://cloudfront.portal.palmtech.com/font-family"
    }
  }
  const allowedFonts = ["arial", "impact", "georgia", "tahoma", "times new roman", "verdana", "helvetica", "courier new", "trebuchet ms", "open sans", "segoe ui", "calibri", "cambria", "lato"];

  const PDF_PAGE_CONTENT_WIDTH = 515;

  function sanitizePdfPercentageSizes(node) {
    if (Array.isArray(node)) {
      node.forEach(sanitizePdfPercentageSizes);
      return;
    }
    if (!node || typeof node !== 'object') return;
    ['width', 'height'].forEach((prop) => {
      if (typeof node[prop] === 'string' && node[prop].trim().endsWith('%')) {
        const percent = parseFloat(node[prop]);
        node[prop] = Number.isNaN(percent) ? undefined : Math.round((percent / 100) * PDF_PAGE_CONTENT_WIDTH);
        if (node[prop] === undefined) delete node[prop];
      }
    });
    if (Array.isArray(node.margin)) {
      node.margin = node.margin.map((m) => {
        if (m === '' || m === null || m === undefined) return 0;
        if (typeof m === 'string' && m.trim().endsWith('%')) {
          const percent = parseFloat(m);
          return Number.isNaN(percent) ? 0 : Math.round((percent / 100) * PDF_PAGE_CONTENT_WIDTH);
        }
        return m;
      });
    }
    if (node.table && Array.isArray(node.table.widths)) {
      node.table.widths = node.table.widths.map((w) => (typeof w === 'string' && w.trim().endsWith('%') ? 'auto' : w));
    }
    if (node.table && Array.isArray(node.table.body)) sanitizePdfPercentageSizes(node.table.body);
    if (Array.isArray(node.text)) sanitizePdfPercentageSizes(node.text);
    if (Array.isArray(node.stack)) sanitizePdfPercentageSizes(node.stack);
    if (Array.isArray(node.columns)) sanitizePdfPercentageSizes(node.columns);
    if (Array.isArray(node.ul)) sanitizePdfPercentageSizes(node.ul);
    if (Array.isArray(node.ol)) sanitizePdfPercentageSizes(node.ol);
  }

  const HTMLtoPDF = async (data) => {
    let newData = data.replace(/font-family:([^;]*)/gi, function (match, fontFamily) {
      const fontList = fontFamily.split(",").map((font) => font.trim().toLowerCase());
      const normalizedFont = fontList.find((font) =>
        allowedFonts.some((allowedFont) => font.includes(allowedFont.toLowerCase()))
      );
      let finalFont = normalizedFont || "Roboto";
      return `font-family: ${finalFont}`;
    });
    newData = newData.replace(new RegExp("Abadi", "gi"), "Roboto");
    newData = newData.replace(/>\s+</g, '><').replace(/\s{2,}/g, ' ').trim();
    const parser = new DOMParser();
    const doc = parser.parseFromString(newData, 'text/html');
    const images = doc.querySelectorAll('img');
    for (let img of images) {
      try {
        if (!img.src.startsWith('data:')) {
          img.src = await imageToBase64(img.src);
        } else {
          img.src = await redrawAsPng(img.src);
        }
      } catch (error) {
        console.error("Error converting image to base64, removing it from the PDF", error);
        img.remove();
      }
    }
    var html = htmlToPdfmake(doc.body.innerHTML?.replace(/^(?!<[^>]+>)(.*)$/gm, "<p>$1</p>"));
    sanitizePdfPercentageSizes(html);
    pdfMake.vfs = pdfFonts?.pdfMake?.vfs;
    const newUrl = fetchUrl()
    pdfMake.fonts = {
      Helvetica: {
        normal: `${newUrl}/Helvetica-normal.otf`,
        bold: `${newUrl}/Helvetica-Bold.ttf`,
        italics: `${newUrl}/Helvetica-Italic.ttf`,
        bolditalics: `${newUrl}/Helvetica-BoldItalic.ttf`,
      },
      TimesNewRoman: {
        normal: `${newUrl}/TNR-Normal.ttf`,
        bold: `${newUrl}/TNR-Bold.ttf`,
        italics: `${newUrl}/TNR-Italic.ttf`,
        bolditalics: `${newUrl}/TNR-BoldItalic.ttf`,
      },
      Arial: {
        normal: `${newUrl}/ARIAL.TTF`,
        bold: `${newUrl}/arial-Bold.ttf`,
        italics: `${newUrl}/ArialItalic.ttf`,
        bolditalics: `${newUrl}/ArialBoldItalic.ttf`,
      },
      Abadi: {
        normal: "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf",
        bold: "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf",
        italics: "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf",
        bolditalics: "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf",
      },
      Roboto: {
        normal: "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf",
        bold: "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf",
        italics: "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf",
        bolditalics: "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf",
      },
      Tahoma: {
        normal: `${newUrl}/tahoma-Regular.ttf`,
        bold: `${newUrl}/tahoma-bold.ttf`,
        italics: `${newUrl}/tahoma-Italic.ttf`,
        bolditalics: `${newUrl}/Tahoma-BoldItalic.ttf`,
      },
      CourierNew: {
        normal: `${newUrl}/CourierNew-Regular.ttf`,
        bold: `${newUrl}/CourierNew-Bold.ttf`,
        italics: `${newUrl}/CourierNew-Italic.ttf`,
        bolditalics: `${newUrl}/CourierNew-BoldItalic.ttf`,
      },
      Impact: {
        normal: `${newUrl}/impact-Normal.ttf`,
        bold: `${newUrl}/impact-Normal.ttf`,
        italics: `${newUrl}/impact-Normal.ttf`,
        bolditalics: `${newUrl}/impact-Normal.ttf`,
      },
      Georgia: {
        normal: `${newUrl}/georgia-Normal.ttf`,
        bold: `${newUrl}/georgia-Bold.ttf`,
        italics: `${newUrl}/georgia-Italic.ttf`,
        bolditalics: `${newUrl}/georgia-BoldItalic.ttf`,
      },
      TrebuchetMs: {
        normal: `${newUrl}/trebuchet-normal.ttf`,
        bold: `${newUrl}/TrebuchetMS-Bold.ttf`,
        italics: `${newUrl}/TrebuchetMS-Italic.ttf`,
        bolditalics: `${newUrl}/TrebuchetMS-BoldItalic.ttf`,
      },
      Verdana: {
        normal: `${newUrl}/verdana-regular.ttf`,
        bold: `${newUrl}/verdana-bold.ttf`,
        italics: `${newUrl}/verdana-italic.ttf`,
        bolditalics: `${newUrl}/verdana-bold-italic.ttf`,
      },
      OpenSans: {
        normal: `${newUrl}/OpenSans-Normal.ttf`,
        bold: `${newUrl}/OpenSans-Bold.ttf`,
        italics: `${newUrl}/OpenSans-Italic.ttf`,
        bolditalics: `${newUrl}/OpenSans-BoldItalic.ttf`,
      },
      SegoeUI: {
        normal: `${newUrl}/SegoeUI-Bold.ttf`,
        bold: `${newUrl}/SegoeUI-Regular.ttf`,
        italics: `${newUrl}/SegoeUI-Italic.ttf`,
        bolditalics: `${newUrl}/SegoeUI-BoldItalic.ttf`,
      },
      Calibri: {
        normal: `${newUrl}/Calibri-Normal.ttf`,
        bold: `${newUrl}/Calibri-Bold.ttf`,
        italics: `${newUrl}/Calibri-Italic.ttf`,
        bolditalics: `${newUrl}/Calibri-boldItalic.ttf`,
      },
      Cambria: {
        normal: `${newUrl}/Cambria-Normal.ttf`,
        bold: `${newUrl}/Cambria-Bold.ttf`,
        italics: `${newUrl}/Cambria-Italic.ttf`,
        bolditalics: `${newUrl}/Cambria-BoldItalic.ttf`,
      },
      Lato: {
        normal: `${newUrl}/Lato-Normal.ttf`,
        bold: `${newUrl}/Lato-Bold.ttf`,
        italics: `${newUrl}/Lato-Italic.ttf`,
        bolditalics: `${newUrl}/Lato-BoldItalic.ttf`,
      },
    };
    var documentDefinition = {
      content: html,
      defaultStyle: { font: "Roboto" },
    };
    pdfMake.createPdf(documentDefinition);
    setPdfFile(pdfMake.createPdf(documentDefinition));
    const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
    pdfDocGenerator?.getBase64((data) => sendSignedAgreement(data));
  };

  const addSignatureNameNDate = () => {
    let signedHTML = `${agreementContent}<p>CLIENT 1</p><p>${clientNameOne} <span>&emsp;&emsp;&emsp;${timestramp1}</span></p>${clientNameTwo !== "" ? `<p>CLIENT 2</p>` : ""
      }<p>${clientNameTwo} <span>&emsp;&emsp;&emsp;${clientNameTwo !== "" ? timestramp2 : ""}</span></p>`;
    HTMLtoPDF(signedHTML);
  };
  const validate = () => {
    let checkboxSpan = document.getElementById("agreeTermsID");
    checkboxSpan.innerHTML = "";
    if (clientNameOne?.trim() === "" || clientNameOne?.trim() === null) {
      setClientNameOneError(true);
      setClientNameOneErrorText("Client name is required");
    } else if (!validator.isLength(clientNameOne?.trim(), { min: 3, max: undefined })) {
      setClientNameOneError(true);
      setClientNameOneErrorText("Minimum 3 characters required");
    } else setClientNameOneError(false);
    if (date1 === null) {
      setDate1Error(true);
      setDate1ErrorText("Date is required");
    } else setDate1Error(false);
    // if(clientNameTwo === '') setDate2(null);
    if (clientNameOne?.trim() !== "" && clientNameOne.trim() !== null && validator.isLength(clientNameOne?.trim(), { min: 3, max: undefined }) && date1 !== null && agreeTerms === false)
      checkboxSpan.innerHTML = "Please check the terms and conditions";
    if (clientNameOne !== "" && clientNameOne !== null && validator.isLength(clientNameOne, { min: 3, max: undefined }) && date1 !== null && agreeTerms === true) {
      addSignatureNameNDate();
    }
  };

  const rejectAgreement = () => {
    setShowLoader(true);
    const formdata = {
      company_id: companyIdParam,
      ip_address: ipAddress,
      browser_info: JSON.stringify({ name: browser.name, browser_version: browser.version, os: removeNumeric(browser.os) }),
      order_id: orderIdParam,
      agreement_id: agreementIdParam,
      email: emailParam,
    };
    apiCall(
      (response) => {
        const { data, message, success } = response.data;
        if (success) {
          setShowLoader(false);
          navigate("/reject-agreement");
        } else {
          console.log("else ", message);
          setShowLoader(false);
        }
      },
      formdata,
      "REJECT_AGREEMENT"
    );
  };

  const froalaClassStyles = {
    "fr-img-caption": "display: inline-block; margin: 10px 0",
    "fr-img-wrap": "display: block; text-align: center",
    "fr-inner": "display: block; text-align: center; font-size: 10px; color: #666",
    "fr-rounded": "border-radius: 10px;",
    "fr-bordered": "border-top: 5px solid #CCCCCC; border-right: 5px solid #CCCCCC; border-bottom: 5px solid #CCCCCC; border-left: 5px solid #CCCCCC; box-sizing: border-box;",
    "fr-highlighted": "border: 1px solid #FF6B6B; border-top: 1px solid #FF6B6B; border-right: 1px solid #FF6B6B; border-bottom: 1px solid #FF6B6B; border-left: 1px solid #FF6B6B; box-sizing: border-box",
    "fr-thick": "border-width: 2px",
    "fr-dii": "display: inline-block; vertical-align: top; margin-right: 18px",
    "fr-shadow": "box-shadow: 0 3px 10px #CCCCCC",
};

const froalaImageDecorationStyles = {
    "fr-rounded": froalaClassStyles["fr-rounded"],
    "fr-bordered": froalaClassStyles["fr-bordered"],
    "fr-shadow": froalaClassStyles["fr-shadow"],
    "fr-highlighted": froalaClassStyles["fr-highlighted"],
    "fr-thick": froalaClassStyles["fr-thick"],
};

const getFroalaImageDecorationStyles = (className = "") => {
    const classes = className.split(/\s+/).filter(Boolean);
    return classes.map((name) => froalaImageDecorationStyles[name]).filter(Boolean).join("; ");
};

const getFroalaRoundedStyle = (className = "") => {
    const classes = className.split(/\s+/).filter(Boolean);
    return classes.includes("fr-rounded") ? froalaClassStyles["fr-rounded"] : "";
};

const mergeInlineStyles = (existingStyle = "", classStyle = "") => {
    return [existingStyle, classStyle].filter(Boolean).join("; ").replace(/;+/g, ";").trim().replace(/;$/, "");
};

const getHighlightedBorderStyle = (borderWidth = "1px") => {
    return `border: ${borderWidth} solid #FF6B6B !important; border-top: ${borderWidth} solid #FF6B6B !important; border-right: ${borderWidth} solid #FF6B6B !important; border-bottom: ${borderWidth} solid #FF6B6B !important; border-left: ${borderWidth} solid #FF6B6B !important`;
};

const toPdfSize = (value) => {
    if (!value) return undefined;
    const trimmed = String(value).trim();
    if (/^auto\b/i.test(trimmed)) return undefined;
    if (trimmed.endsWith("px")) return parseFloat(trimmed);
    if (trimmed.endsWith("%")) return trimmed;
    const numeric = parseFloat(trimmed);
    return Number.isNaN(numeric) ? undefined : numeric;
};

const getImageDimension = (attrs = "", dimension, fallback) => {
    const styleMatch = attrs.match(new RegExp(`${dimension}:\\s*([^;\"]+)`, "i"));
    const styleValue = styleMatch ? styleMatch[1].trim() : "";
    if (styleValue && !/^auto\b/i.test(styleValue)) return styleValue;
    const attrMatch = attrs.match(new RegExp(`${dimension}=["']?([^"'\\s>]+)`, "i"));
    return attrMatch ? attrMatch[1].trim() : fallback;
};

const toCssSize = (value) => {
    if (!value) return undefined;
    const trimmed = String(value).trim();
    if (trimmed.endsWith("px") || trimmed.endsWith("%")) return trimmed;
    const numeric = parseFloat(trimmed);
    return Number.isNaN(numeric) ? trimmed : `${numeric}px`;
};

const getDefaultImageHeight = (width) => {
    const numericWidth = toPdfSize(width);
    return typeof numericWidth === "number" ? Math.round(numericWidth * 0.35) : 105;
};

const DEFAULT_IMAGE_CONTAINER_WIDTH = 300;

const toPdfPixelSize = (value, fallback) => {
    if (!value) return fallback;
    const trimmed = String(value).trim();
    if (trimmed.endsWith("%")) {
        const percent = parseFloat(trimmed);
        return Number.isNaN(percent) ? fallback : Math.round((percent / 100) * DEFAULT_IMAGE_CONTAINER_WIDTH);
    }
    const size = toPdfSize(trimmed);
    return typeof size === "number" ? size : fallback;
};

function buildCaptionedImageBlock(captionClasses, imgAttrs, caption) {
        const srcMatch = imgAttrs.match(/src="([^"]*)"/);
        const src = srcMatch ? srcMatch[1] : '';
        const imageWidth = getImageDimension(imgAttrs, 'width', '300');
        const imageHeight = getImageDimension(imgAttrs, 'height', getDefaultImageHeight(imageWidth));
        const classMatch = imgAttrs.match(/class="([^"]*)"/);
        const imageClasses = classMatch ? classMatch[1] : '';
        const widthValue = toPdfPixelSize(imageWidth, DEFAULT_IMAGE_CONTAINER_WIDTH);
        const heightValue = toPdfPixelSize(imageHeight, getDefaultImageHeight(widthValue));
        const widthStyle = `width: ${toCssSize(imageWidth)}`;
        const heightStyle = `height: ${toCssSize(imageHeight)}`;
        const imageDecorationStyle = mergeInlineStyles(getFroalaImageDecorationStyles(captionClasses), getFroalaImageDecorationStyles(imageClasses))
            .replace(/outline:\s*[^;]+;?/gi, '')
            .replace(/outline-offset:\s*[^;]+;?/gi, '')
            .replace(/box-sizing:\s*border-box;?/gi, 'box-sizing: content-box;');
        const alignmentStyle = captionClasses.includes('fr-fir')
            ? 'margin: 5px 0 10px auto'
            : captionClasses.includes('fr-fil')
                ? 'margin: 5px auto 10px 0'
                : 'margin: 5px auto 10px auto';
        const imageFrameStyle = 'display: inline-block; line-height: 0';
        const roundedStyle = getFroalaRoundedStyle(imageClasses) ? `border-radius: 10px; overflow: hidden;` : '';
        const imageStyle = mergeInlineStyles(`${widthStyle}; ${heightStyle}; max-width: 100%; object-fit: contain; display: block; box-sizing: content-box; ${roundedStyle}`, imageDecorationStyle);
        const captionStyle = `
  display:block;
  width:100%;
  text-align:center;
  font-size:10px;
  color:#666;
  line-height:normal;
  margin-top:5px;
`;
        return `<div style="display: block; ${widthStyle}; ${alignmentStyle}; text-align: center"><span style="${imageFrameStyle}"><img src="${src}" width="${widthValue}" height="${heightValue}" style="${imageStyle}"></span><div style="${captionStyle}">${caption}</div></div>`;
    }

     function convertFontTagsToInlineStyles(html) {
         if (!html) return "";
        html = html.replace(/(\w[\w-]*)=""+([^"]*?)""+/g, '$1="$2"');
        html = html.replace(/\s*fr-original-style=(["'])(?:\\\1|.)*?\1/g, '');
        html = html.replace(/\s*fr-original-class=(["'])(?:\\\1|.)*?\1/g, '');
        html = html.replace(/<p>\s*<span class="([^"]*fr-img-caption[^"]*)"[^>]*>\s*<span class="fr-img-wrap">\s*<img([^>]*)>\s*<span class="fr-inner">([^<]*)<\/span>\s*<\/span>\s*<\/span>\s*<\/p>\s*<p>(?!\s*<br\s*\/?\s*>)([\s\S]*?)<\/p>/gi, (match, captionClasses, imgAttrs, caption, textContent) => {
            const imageBlock = buildCaptionedImageBlock(captionClasses, imgAttrs, caption);
            if (captionClasses.includes('fr-dii') && (captionClasses.includes('fr-fil') || captionClasses.includes('fr-fir'))) {
                const textBlock = `<div style="flex: 1; font-size: 12px; padding-right: 8px">${textContent}</div>`;
                const imageColumnWidth = getImageDimension(imgAttrs, 'width', '300');
                const imageColumn = `<div style="width: ${toCssSize(imageColumnWidth)}">${imageBlock}</div>`;
                if (captionClasses.includes('fr-fil')) {
                    return `<div style="display: flex; flex-direction: row; align-items: flex-start; margin-bottom: 10px">${imageColumn}<div style="flex: 1; font-size: 12px; padding-left: 8px">${textContent}</div></div>`;
                }
                return `<div style="display: flex; flex-direction: row; align-items: flex-start; margin-bottom: 10px">${textBlock}${imageColumn}</div>`;
            }
            return `${imageBlock}<p>${textContent}</p>`;
        });
        html = html.replace(/<p>\s*<span class="([^"]*fr-img-caption[^"]*)"[^>]*>\s*<span class="fr-img-wrap">\s*<img([^>]*)>\s*<span class="fr-inner">([^<]*)<\/span>\s*<\/span>\s*<\/span>\s*<\/p>/gi, (match, captionClasses, imgAttrs, caption) => buildCaptionedImageBlock(captionClasses, imgAttrs, caption));
        html = html.replace(/<col([^>]*)>/gi, '<col>');
        html = html.replace(/class="([^"]*)fr-highlighted([^"]*)"/gi, (match, before, after) => {
            const classes = `${before}${after}`.trim();
            const otherClasses = classes.replace(/fr-highlighted/gi, '').trim();
            return otherClasses ? `class="${otherClasses}" data-highlight="true"` : 'data-highlight="true"';
        });
        html = html.replace(/<t([dh])([^>]*)data-highlight="true"([^>]*)>/gi, (match, cellType, attrs1, attrs2) => {
            const fullAttrs = attrs1 + attrs2;
            if (fullAttrs.includes('style="')) {
                return match.replace(/style="([^"]*)"/i, (_, styleContent) => {
                    const widthMatch = styleContent.match(/border-width:\s*([^;]+)/i) || styleContent.match(/border:\s*([^;\s]+)/i);
                    return `style="${mergeInlineStyles(styleContent, getHighlightedBorderStyle(widthMatch?.[1] || '1px'))}"`;
                });
            }
            return `<t${cellType}${fullAttrs} style="${getHighlightedBorderStyle()}">`;
        });
        html = html.replace(
            /<tbody([^>]*)>([\s\S]*?)<\/tbody>\s*<tfoot[^>]*>([\s\S]*?)<\/tfoot>/gi,
            (match, tbodyAttrs, tbodyContent, footerContent) => {
                const styledFooter = footerContent.replace(
                    /<tr([^>]*)>/gi,
                    '<tr$1 data-footer="true">'
                );
                return `<tbody${tbodyAttrs}>${tbodyContent}${styledFooter}</tbody>`;
            }
        );
        html = html.split('<table').map((section, idx) => {
            if (idx === 0) return section;
            const isDashedTable = /(?:^|[\s"'])(?:dashed-table|fr-dashed-borders)(?:[\s"']|$)/i.test(section);
            const isAlternateRowsTable = section.includes('alternate-rows');
            const tableEndIdx = section.indexOf('</table>');
            if (tableEndIdx === -1) return '<table' + section;
            const tableContent = section.substring(0, tableEndIdx);
            const afterTable = section.substring(tableEndIdx);
            const defaultBorderStyle = isDashedTable ? '1px dashed #999' : '1px solid #999';
            let rowIndex = 0;
            let normalizedTableContent = tableContent;
            if (isDashedTable) {
                normalizedTableContent = normalizedTableContent.replace(/<t([dh])([^>]*)>/gi, (cellMatch, cellType, cellAttrs) => {
                    if (/data-highlight=["']true["']/i.test(cellAttrs) || cellAttrs.includes('#FF6B6B')) return cellMatch;
                    const dashedBorderStyle = 'border:1px dashed #999 !important; border-top:1px dashed #999 !important; border-right:1px dashed #999 !important; border-bottom:1px dashed #999 !important; border-left:1px dashed #999 !important; border-style:dashed !important; border-color:#999 !important';
                    if (/\sstyle="[^"]*"/i.test(cellAttrs)) {
                        return `<t${cellType}${cellAttrs.replace(/\sstyle="([^"]*)"/i, (_, styleContent) => {
                            const cleanedStyle = styleContent
                                .replace(/border-(top|right|bottom|left)(?:-(width|style|color))?:\s*[^;]+;?/gi, '')
                                .replace(/border:\s*[^;]+;?/gi, '')
                                .replace(/border-width:\s*[^;]+;?/gi, '')
                                .replace(/border-style:\s*[^;]+;?/gi, '')
                                .replace(/border-color:\s*[^;]+;?/gi, '');
                            return ` style="${mergeInlineStyles(cleanedStyle, dashedBorderStyle)}"`;
                        })}>`;
                    }
                    return `<t${cellType}${cellAttrs} style="${dashedBorderStyle}">`;
                });
            }
            const updatedContent = normalizedTableContent.replace(/<tr([^>]*)>([\s\S]*?)<\/tr>/gi, (rowMatch, rowAttrs, rowContent) => {
                const HEADER_COLOR = '#ececec';
                const ALTERNATE_ROW_COLOR = '#f5f5f5';
                const isHeaderRow = rowContent.includes('<th');
                const isFooterRow = rowMatch.includes('data-footer="true"');
                const rowBackground = isAlternateRowsTable && !isHeaderRow && !isFooterRow && rowIndex++ % 2 === 1 ? ALTERNATE_ROW_COLOR : null;
                const updatedRowContent = rowContent.replace(/<t(d|h)([^>]*)>/gi, (cellMatch, cellType, cellAttrs) => {
                    const hasStyle = cellAttrs.includes('style="');
                    const isHighlightedCell = /data-highlight=["']true["']/i.test(cellAttrs);
                    const applyStyle = (styleContent = '') => {
                        const existingBorder = styleContent.match(/border:\s*([^;]+)/)?.[1];
                        const existingBorderWidth = styleContent.match(/border-width:\s*([^;]+)/)?.[1] || existingBorder?.split(/\s+/)[0];
                        const isHighlighted = isHighlightedCell || styleContent.includes('#FF6B6B');
                        const borderColor = isHighlighted ? '#FF6B6B' : styleContent.match(/border-color:\s*([^;]+)/)?.[1] || existingBorder?.split(/\s+/).slice(2).join(' ') || '#999';
                        const borderWidth = isHighlighted ? existingBorderWidth || '1px' : existingBorderWidth || defaultBorderStyle.split(' ')[0];
                        const borderKind = isHighlighted ? 'solid' : isDashedTable ? 'dashed' : existingBorder?.split(/\s+/)[1] || defaultBorderStyle.split(' ')[1];
                        const finalBorder = `${borderWidth} ${borderKind} ${borderColor}`;
                        const existingBackgroundColor = styleContent.match(/background-color:\s*([^;]+)/)?.[1]?.trim();
                        const cleanedStyle = styleContent
                            .replace(/border-(top|right|bottom|left)(?:-(width|style|color))?:\s*[^;]+;?/g, '')
                            .replace(/border:\s*[^;]+;?/g, '')
                            .replace(/border-width:\s*[^;]+;?/g, '')
                            .replace(/border-style:\s*[^;]+;?/g, '')
                            .replace(/border-color:\s*[^;]+;?/g, '')
                            .replace(/background-color:\s*[^;]+;?/g, '')
                            .trim();

                        const hasTextAlign = /text-align\s*:/i.test(styleContent);

                        let cellBackgroundStyle = '';
                        if (cellType === 'h') {
                            cellBackgroundStyle = `background-color: ${HEADER_COLOR} !important; font-weight: bold; font-size: 16px;${hasTextAlign ? '' : ' text-align: left;'}`;
                        } else if (isFooterRow) {
                            cellBackgroundStyle = `background-color: ${HEADER_COLOR} !important; font-size: 16px;`;
                        } else if (existingBackgroundColor) {
                            cellBackgroundStyle = `background-color: ${existingBackgroundColor} !important;`;
                        } else if (rowBackground) {
                            cellBackgroundStyle = `background-color: ${rowBackground} !important;`;
                        }

                        const borderStyle = isHighlighted ? getHighlightedBorderStyle(borderWidth) : `border: ${finalBorder}; border-top: ${finalBorder}; border-right: ${finalBorder}; border-bottom: ${finalBorder}; border-left: ${finalBorder};`;

                        const finalStyles = [cleanedStyle, cellBackgroundStyle, borderStyle].filter(s => s.trim()).join(' ');
                        return finalStyles;
                    };
                    if (hasStyle) {
                        return cellMatch.replace(/style="([^"]*)"/i, (styleMatch, styleContent) => `style="${applyStyle(styleContent)}"`);
                    }
                    return `<t${cellType}${cellAttrs} style="${applyStyle()}">`;
                });
                return `<tr${rowAttrs}>${updatedRowContent}</tr>`;
            });
            return '<table' + updatedContent + afterTable;
        }).join('');
        html = html.replace(/font-family:\s*["']([^"']*?)["']/gi, 'font-family: $1');
        html = html.replace(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/g, (match, r, g, b) => {
            const hex = '#' + [parseInt(r), parseInt(g), parseInt(b)].map(x => x.toString(16).padStart(2, '0')).join('');
            return hex;
        });
        html = html.replace(/<table([^>]*)class="([^"]*dashed-table[^"]*?)"([^>]*)>/gi, (match, before, classes, after) => {
            let tableAttrs = `${before}class="${classes}"${after}`;
            const dashedTableStyle = 'border:1px dashed #999; border-top:1px dashed #999; border-right:1px dashed #999; border-bottom:1px dashed #999; border-left:1px dashed #999';
            if (/\sstyle="[^"]*"/i.test(tableAttrs)) {
                tableAttrs = tableAttrs.replace(/\sstyle="([^"]*)"/i, (_, styleContent) => {
                    const cleanedStyle = styleContent.replace(/border[^;]*;?/gi, '');
                    return ` style="${mergeInlineStyles(cleanedStyle, dashedTableStyle)}"`;
                });
            } else {
                tableAttrs += ` style="${dashedTableStyle}"`;
            }
            return `<table${tableAttrs}>`;
        });
        html = html.replace(/<t(d|h)([^>]*)>(?=([^<]*<\/t\1>([^<]*<t(d|h)|[^<]*<\/t(?:body|foot|head)|[^<]*<\/table))|[^<]*<\/t(?:body|foot|head)|[^<]*<\/table)/gi, (match, cellType, attrs) => {
            const isDashedTableCell = /<table[^>]*class="[^"]*dashed-table/i.test(html.substring(Math.max(0, html.indexOf(match) - 5000)));
            if (!isDashedTableCell) return match;
            if (/data-highlight=["']true["']/i.test(attrs) || attrs.includes('#FF6B6B')) return match;
            const dashedCellStyle = 'border:1px dashed #999; border-top:1px dashed #999; border-right:1px dashed #999; border-bottom:1px dashed #999; border-left:1px dashed #999';
            if (/\sstyle="[^"]*"/i.test(attrs)) {
                return `<t${cellType}${attrs.replace(/\sstyle="([^"]*)"/i, (_, styleContent) => {
                    const cleanedStyle = styleContent.replace(/border[^;]*;?/gi, '');
                    return ` style="${mergeInlineStyles(cleanedStyle, dashedCellStyle)}"`;
                })}>`;
            }
            return `<t${cellType}${attrs} style="${dashedCellStyle}">`;
        });
        html = html.replace(/style=["']([^"']*?)["']/g, (match, styles) => {
            let cleaned = styles
                .replace(/;+/g, ';')
                .trim()
                .replace(/;$/, '')
                .replace(/;\s+/g, '; ');
            return cleaned ? ` style="${cleaned}"` : '';
        });
        html = html.replace(/\s+class="([^"]*)"/gi, (match, classes) => {
            const remainingClasses = classes.split(/\s+/).filter((className) => className && !className.startsWith('fr-')).join(' ');
            return remainingClasses ? ` class="${remainingClasses}"` : '';
        });
        const dashedBorderInline = 'border: 1px dashed #999 !important; border-top: 1px dashed #999 !important; border-right: 1px dashed #999 !important; border-bottom: 1px dashed #999 !important; border-left: 1px dashed #999 !important;';
        html = html.replace(/<table[^>]*class="[^"]*dashed-table[^"]*"[^>]*>/g, (tableStart) => {
            if (/style="[^"]*"/i.test(tableStart)) {
                return tableStart.replace(/style="([^"]*)"/i, (_, styles) => {
                    const cleaned = styles.replace(/border[^;]*;?/gi, '');
                    return 'style="' + cleaned + ' ' + dashedBorderInline + '"';
                });
            }
            return tableStart + ' style="' + dashedBorderInline + '"';
        });
        html = html.replace(/(<table[^>]*class="[^"]*dashed-table[^"]*"[^>]*>[\s\S]*?)<\/table>/gi, (match, tableStart) => {
            const tableEnd = '</table>';
            const tableContent = match.substring(0, match.length - tableEnd.length);
            const updatedContent = tableContent.replace(/<t(d|h)([^>]*)>/g, (cellTag, cellType, cellAttrs) => {
                if (cellAttrs.includes('style="')) {
                    return cellTag.replace(/style="([^"]*)"/i, (_, styles) => {
                        const cleaned = styles.replace(/border[^;]*;?/gi, '');
                        return 'style="' + cleaned + ' ' + dashedBorderInline + '"';
                    });
                }
                return '<t' + cellType + cellAttrs + ' style="' + dashedBorderInline + '">';
            });
            return updatedContent + tableEnd;
        });
        html = html.replace(/\s+data-highlight="true"/gi, '');
        html = html.replace(/\s+data-thick="true"/gi, '');
        html = html.replace(/\s+data-footer="true"/gi, '');
        html = html.replace(/\s+data-pdf-layout="image-text"/gi, '');
        html = html.replace(/<img([^>]*)(?<!\/)\s*>/gi, '<img$1 />');
        html = html.replace(/>\s*>/g, '>');
        html = html.replace(/&nbsp;/g, ' ');
        return html.trim();
    }
  // function convertFontTagsToInlineStyles(htmlString) {
  //   var convertedString = htmlString
  //     ?.replace(/<font([^>]*)>/gi, function (match, p1) {
  //       var attributes = p1?.split(/\s+/);
  //       var styles = "";
  //       for (var i = 0; i < attributes?.length; i++) {
  //         var attribute = attributes[i]?.trim();
  //         var parts = attribute?.split("=");
  //         if (parts.length === 2) {
  //           var name = parts[0]?.toLowerCase();
  //           var value = parts[1]?.replace(/['"]/g, "");
  //           // eslint-disable-next-line
  //           switch (name) {
  //             case "color":
  //               styles += "color: " + value + "; ";
  //               break;
  //             case "size":
  //               styles += "font-size: " + fontSizeConverter(value) + "px !important; ";
  //               break;
  //           }
  //         }
  //       }
  //       return "<span style='" + styles + "'>";
  //     });
  //   convertedString = convertedString?.replace(/<\/font>/gi, "</span>");
  //   return convertedString;
  // }

  const fontSizeConverter = (val) => {
    if (val === "1") {
      return 10;
    } else if (val === "2") {
      return 13;
    } else if (val === "3") {
      return 16;
    } else if (val === "4") {
      return 18;
    } else if (val === "5") {
      return 24;
    } else if (val === "6") {
      return 32;
    } else if (val === "7") {
      return 48;
    } else return val;
  };
  // const uploadFile=(e)=>{
  //    setFile(e.target.files[0])
  // }
  useEffect(() => {
    if (sessionStorage.getItem("timezone") === null) {
      axios
        .get("https://ipapi.co/json/?key=EJ1FHhnqyB6gRoAik4SRHnb8peb3wBAapbY93Q7TZkYZ0Tsu5R")
        .then((response) => {
          sessionStorage.setItem("timezone", response?.data?.timezone);
          GetAgreementDetails();
        })
        .catch((error) => {
          console.log("error", error);
        });
    } else GetAgreementDetails();
  }, []);

  return (
    <Box className="web-view-wrapper">
      <Preloader showPreloader={showLoader} />
      <Grid container spacing={2} className="web-view-container">
        <Grid container className="web-view-content">
          <h3>Review and sign the Agreement</h3>
          <div className="agreement-view fr-view" dangerouslySetInnerHTML={{ __html: agreementContent }} />
          <Grid item xs={12} className="agreement_consent">
            <FormControlLabel
              control={
                <Checkbox
                  color="default"
                  onChange={(e) => {
                    setAgreeTerms(e.target.checked);
                  }}
                  icon={<RadioButtonUncheckedIcon />}
                  checkedIcon={<CheckCircleIcon />}
                />
              }
              label="* I have carefully read this agreement and agree to the terms and conditions above."
            />
          </Grid>
          <Grid item xs={12} id="agreeTermsID"></Grid>
          <Grid item xs={6} sm={3}>
            <FormControl variant="standard" className="forms-control-webview">
              <label className="input-form-label" htmlFor="Address" id="demo-simple-select-label">
                Client 1*
              </label>
              <TextField
                id="firstName"
                className="input-textfield"
                size="small"
                variant="outlined"
                placeholder="Full Name"
                // value={firstName}
                onChange={(e) => setClientNameOne(e.target.value)}
                error={clientNameOneError}
                helperText={`${clientNameOneError ? clientNameOneErrorText : ""}`}
                type="text"
              />
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={3}>
            <FormControl variant="standard" className="forms-control-webview">
              <label className="input-form-label" htmlFor="Address" id="demo-simple-select-label">
                Date*
              </label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  value={new Date(date1)}
                  inputFormat="dd-MM-yyyy"
                  minDate={new Date()}
                  className={"inspection-filter-modal-select"}
                  sx={{
                    height: "40px !important",
                    '.MuiInputBase-root.MuiOutlinedInput-root': {
                      height: "40px !important",
                    },
                  }}
                  onChange={(newValue) => setDate1(newValue)}
                  error={date1Error}
                  helperText={`${date1Error ? date1ErrorText : ""}`}
                  renderInput={(params) => <TextField sx={{ height: "40px !important" }} {...params} size="small" />}
                />
              </LocalizationProvider>
            </FormControl>
          </Grid>
          {/* ============================================================================================== */}
          <Grid item xs={6} sm={3}>
            <FormControl variant="standard" className="forms-control-webview">
              <label className="input-form-label" htmlFor="Address" id="demo-simple-select-label">
                client 2
              </label>
              <TextField
                id="firstName"
                className="input-textfield"
                size="small"
                variant="outlined"
                placeholder="Full Name"
                onChange={(e) => setClientNameTwo(e.target.value)}
                error={clientNameTwoError}
                helperText={`${clientNameTwoError ? clientNameOneErrorText : ""}`}
                type="text"
              />
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={3}>
            <FormControl variant="standard" className="forms-control-webview">
              <label className="input-form-label" htmlFor="Address" id="demo-simple-select-label">
                Date
              </label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  value={new Date(date2)}
                  inputFormat="dd-MM-yyyy"
                  minDate={new Date()}
                  className={"inspection-filter-modal-select"}
                  onChange={(newValue) => setDate2(newValue)}
                  sx={{
                    height: "40px !important",
                    '.MuiInputBase-root.MuiOutlinedInput-root': {
                      height: "40px !important",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{ height: "40px !important" }}
                      inputProps={{ ...params.inputProps, placeholder: "hh:mm am/pm" }}
                      size="small"
                    />
                  )}
                />
              </LocalizationProvider>
            </FormControl>
          </Grid>
          {/* below code might be required later */}
          {/* ================================================================================================= */}
          {/* test input */}
          {/* <Grid item xs={6} sm={3}>
            <FormControl variant="standard" className="forms-control-webview">
              <label
                className="input-form-label"
                htmlFor="Address"
                id="demo-simple-select-label"
              >
                pdf
              </label>
              <input id='inputPDF'
                  // ref={fileInput}
                  accept=".pdf" type="file" onChange={uploadFile}
      />           
            </FormControl>
          </Grid> */}
          {/* test input */}
          <Grid item xs={12} className="agreement-action">
            <div></div>
            <div className="right-btn-group">
              <Button onClick={validate} className="agree-btn">
                Agree
              </Button>
              <Button className="reject-btn" onClick={rejectAgreement}>
                <span className="reject-text">Reject</span>
              </Button>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AgreementWebViewNSignature;
